import { render } from "./TablesPage.vue?vue&type=template&id=180bdab1&ts=true"
import script from "./TablesPage.vue?vue&type=script&lang=ts"
export * from "./TablesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__